import type { DefconLevel, GameState } from '../types/game-state';

function getDefconDescription(level: DefconLevel): string {
  switch (level) {
    case 5: return 'FADE OUT - NORMAL READINESS';
    case 4: return 'DOUBLE TAKE - INCREASED READINESS';
    case 3: return 'ROUND HOUSE - AIR FORCE READY TO MOBILIZE';
    case 2: return 'FAST PACE - ARMED FORCES READY FOR DEPLOYMENT';
    case 1: return 'COCKED PISTOL - NUCLEAR WAR IMMINENT';
  }
}

function getDefconCssClass(level: DefconLevel): string {
  return `defcon-${level}`;
}

function shouldEscalateDefcon(state: GameState): boolean {
  return state.defconLevel > 1;
}

export { getDefconDescription, getDefconCssClass, shouldEscalateDefcon };
